export default __webpack_public_path__ + "static/media/connect-01.a62eb0ea.png";